import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createElement } from 'react';
export function RichTextEditorElement(param) {
    let { attributes, element, children } = param;
    const getElementDetails = ()=>{
        const type = element.typ;
        if (type === 'a') {
            return [
                'a',
                _object_spread_props(_object_spread({}, attributes), {
                    href: element.url
                })
            ];
        }
        return [
            type,
            attributes
        ];
    };
    const [elementToRender, attrs] = getElementDetails();
    return createElement(elementToRender, attrs, children);
}
